@if (!!appointment && participants$ | async; as participants) {
  <div
    class="appointment-info card active"
    [ngClass]="{
        canceled: appointment.appointmentStatus === canceledAppointment
    }"
    >
    <!-- Design refresh (OVS-2565): flex columns that wrap with the card width -->
    <div class="appointment-card-body">
      <div class="appointment-time">
        <div class="appointment-start-time">
          <i class="fal fa-clock" aria-hidden="true"></i>
          @if (isAppointmentToday) {
            <span>
              {{ "APPOINTMENT.INFO.TODAY" | translate }}
              {{ appointment.startDateTime | date : "HH:mm" }}
              {{ "APPOINTMENT.INFO.TIME-MAIN-SPECIFIER" | translate }}
            </span>
          } @else {
            <span>
              {{ appointment.startDateTime | date : "dd.LL.yyyy HH:mm" }}
              {{ "APPOINTMENT.INFO.TIME-MAIN-SPECIFIER" | translate }}
            </span>
          }
        </div>
        <div class="appointment-duration">
          <span>{{ appointment.period }}</span>
        </div>
        <div class="appointment-end-time">
          <i class="fal fa-dot-circle" aria-hidden="true"></i>
          <span>
            {{ appointment.endDateTime | date : "HH:mm" }}
            {{ "APPOINTMENT.INFO.TIME-MAIN-SPECIFIER" | translate }}
          </span>
        </div>
      </div>
      <div class="patient-info-wrapper">
        <div class="participants">
          @for (
            participant of participants
            | slice : 0 : visibleParticipants
            ; track
            participant) {
            <div class="participant">
              <div class="patient-info patient-head">
                @if (appointment.appointmentStatus === canceledAppointment) {
                  <span class="canceled-text">{{
                    "APPOINTMENT.STATUS.CANCELED" | translate
                  }}</span>
                } @else if (participant?.tan) {
                  <span
                    class="tan"
                    ngxClipboard
                    [cbContent]="tanLoginLink + participant.tan"
                    ngbTooltip="{{
                        'APPOINTMENT.TAN-CREATE-SUCCESSFUL.TAN-COPIED'
                            | translate
                    }}"
                    [autoClose]="true"
                    placement="bottom"
                    triggers="manual"
                    #tooltip="ngbTooltip"
                    (cbOnSuccess)="toggleTooltip(tooltip)"
                    >
                    <i class="fal fa-ticket-alt" aria-hidden="true"></i>
                    {{ participant.tan }}
                  </span>
                }
                @if (participant?.fullName) {
                  <span class="user-name">{{ participant.fullName }}</span>
                }
              </div>
              @if (participant?.birthday) {
                <div class="patient-info">
                  <span class="label">{{
                    "APPOINTMENT.INFO.PATIENT-EMAIL-BIRTH-DATE" | translate
                  }}:</span>&ngsp;<span>{{ participant?.birthday | date : "dd.MM.yyyy" }}</span>
                </div>
              }
              @if (participant?.email) {
                <div class="patient-info">
                  <span class="label">{{
                    "APPOINTMENT.INFO.PATIENT-EMAIL-LABEL" | translate
                  }}:</span>&ngsp;<a href="mailto:{{ participant.email }}" class="email-link">{{
                    participant.email
                  }}</a>
                </div>
              }
            </div>
          }
        </div>
        @if (participants.length > defaultVisibleParticipants) {
          <div>
            <button
              type="button"
              class="btn btn-link no-padding toggle-participants"
              (click)="toggleParticipants(participants.length)"
              >
              @if (visibleParticipants === defaultVisibleParticipants) {
                {{
                  "APPOINTMENT.INFO.PATIENTS-TOGGLE-BTN-SHOW-MORE"
                    | translate
                      : {
                          numOfPart:
                            participants.length - defaultVisibleParticipants
                        }
                }}
                <span><i class="fa fa-caret-up"></i></span>
              } @else {
                {{ "APPOINTMENT.INFO.PATIENTS-TOGGLE-BTN-SHOW-LESS" | translate }}
                <span><i class="fa fa-caret-down"></i></span>
              }
            </button>
          </div>
        }
        @if (appointment.appointmentMessage) {
          <div class="message">
            <i class="fal fa-comment-alt" aria-hidden="true"></i>
            <div class="message-body">
              <span class="message-title">{{
                "APPOINTMENT.INFO.APPOINTMENT_MESSAGE_TITLE" | translate
              }}</span>
              <span class="message-text">{{ appointment.appointmentMessage }}</span>
            </div>
          </div>
        }
      </div>
      @if (appointmentInfoType === upComingAppointmentInfoType) {
        <div class="appointment-action-buttons">
          <button
            type="button"
            class="btn btn-primary"
            [class.btn-loading]="vonageLoading$ | async"
            [disabled]="vonageLoading$ | async"
            (click)="start()"
            >
            <span>
              <i class="fal fa-play" aria-hidden="true"></i>
              {{ "APPOINTMENT.INFO.START" | translate }}
            </span>
          </button>
          @if (canDeleteAppointment) {
            <button
              type="button"
              class="btn btn-delete"
              (click)="openDeleteAppointment()"
              >
              <span>
                <i class="fal fa-trash-alt" aria-hidden="true"></i>
                {{ "APPOINTMENT.BUTTON.DELETE" | translate }}
              </span>
            </button>
          }
        </div>
      }
    </div>
  </div>
}
